var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrmMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M339.4 548.4h347.8c19.2 0 34.8 15.6 34.8 34.8S706.4 618 687.2 618H339.4c-19.2 0-34.8-15.6-34.8-34.8s15.6-34.8 34.8-34.8zm52.2-156.5h243.5c19.2 0 34.8 15.6 34.8 34.8s-15.6 34.8-34.8 34.8H391.6c-19.2 0-34.8-15.6-34.8-34.8s15.6-34.8 34.8-34.8zM96 513.6C96 283.1 282.8 96.2 513.3 96.2s417.4 186.9 417.4 417.4c0 100.3-35.6 195.1-98.7 269.6l58.8 58.7c9.8 9.8 15.3 23.1 15.3 36.9 0 28.8-23.4 52.2-52.2 52.2h-358c-2.5 0-4.9-.2-7.2-.7C269 917.5 96 735.2 96 513.6zm663.2 295.2c-13.6-13.6-13.6-35.6 0-49.2 64.9-64.8 102-152.5 102-246 0-192.1-155.7-347.8-347.8-347.8S165.5 321.5 165.5 513.6c0 186.3 146.8 339.3 332.3 347.5 1.2.1 2.5.2 3.6.3h310.4l-52.6-52.6z"
  })));
}

export default SvgCrmMessage;